import { useNavigate } from "react-router-dom";
import { styled } from "styled-components";
import { IArticle } from "./HelpCenter.config";
import { useAppLayout } from "@dataone/lib";
import { useSmartSearch } from "../../smart-search/contexts/smart-search.provider";

interface HelpCenterCardProps {
  title: string;
  icon: JSX.Element;
  content: IArticle[];
  path: string;
  iContactCard: boolean;
}

const HelpCenterCard = ({
  title,
  icon,
  path,
  content,
  iContactCard,
}: HelpCenterCardProps) => {
  const navigate = useNavigate();
  const handleViewMore = () => {
    navigate(path);
  };

  const {
    setShowResponse,
    setResponse,
    setSearchMessageError,
    setSearchSuggestionsError,
  } = useSmartSearch();

  const handleNavigate = (path: string, isProductTour = false) => {
    if (isProductTour) {
      useAppLayout.setState({ isResponseVisible: false });
      setShowResponse(false);
      setResponse((prev) => ({ ...prev, id: undefined }));
      setSearchMessageError("");
      setSearchSuggestionsError([]);

      navigate(path, { state: { productTour: "/dashboard" } });
    } else navigate(path);
  };

  return (
    <StyledHelpCenterCard>
      <StyledIcon>{icon}</StyledIcon>
      <Title>{title}</Title>
      {!iContactCard ? (
        <>
          {content.slice(0, 3).map((subTitle, index) => {
            return (
              <StyledLink
                onClick={() =>
                  handleNavigate(subTitle.path!, subTitle.isProductTour)
                }
                key={index}
              >
                {subTitle.title}
              </StyledLink>
            );
          })}
          {content.length > 3 && (
            <ViewMore onClick={handleViewMore}>View more </ViewMore>
          )}
        </>
      ) : (
        <ContactContent>
          <ContactLink onClick={() => handleNavigate("/support/contact-us")}>
            Create a support ticket
          </ContactLink>
          <p style={{ margin: "6px 0px" }}>we’ll get back to you soon</p>
        </ContactContent>
      )}
    </StyledHelpCenterCard>
  );
};

export default HelpCenterCard;

const StyledHelpCenterCard = styled.div`
  // width: 26%;
  height: 256px;
  width: 28%;
  background: #eff1fd;
  padding: 30px 10px 5px 25px;
  margin-bottom: 50px;
  border-radius: 20px;
  position: relative;
`;
const Title = styled.h3`
  font-weight: 700;
  font-size: 14px;
`;
const StyledLink = styled.p`
  color: #4974f6;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
`;
const ViewMore = styled.p`
  text-decoration: underline;
  font-weight: 700;
  color: #4974f6;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
`;
const StyledIcon = styled.div`
  position: absolute;
  top: -28px;
  left: calc(50% - 27px);
  background: #fff;
  padding: 10px;
  border-radius: 50%;
  border: 1.5px solid #eff1fd;
  color: #4974f6;
  font-size: 35px;
  display: flex;
`;
const ContactLink = styled.p`
  color: #4974f6;
  font-size: 15px;
  margin: 0px;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
`;
const ContactContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 50%;
`;
